import React from 'react';
import { FiFilter } from 'react-icons/fi';
import styles from '../AnnouncementsV2.module.css';

const FiltersButton = ({ isActive, onClick }) => {
  return (
    <button
      className={`${styles.filtersButton} ${isActive ? styles.filtersButtonActive : ''}`}
      onClick={onClick}
    >
      <FiFilter size={18} />
      Filters
    </button>
  );
};

export default FiltersButton;
